import { render } from "./VoiceView.vue?vue&type=template&id=a155e52e&scoped=true"
import script from "./VoiceView.vue?vue&type=script&lang=js"
export * from "./VoiceView.vue?vue&type=script&lang=js"

import "./VoiceView.vue?vue&type=style&index=0&id=a155e52e&lang=scss&scoped=true"

import exportComponent from "/home/lw8dl1214/actions-runner/_work/AIPR-Frontend/AIPR-Frontend/haleon-ar-detector/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a155e52e"]])

export default __exports__